var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSampleProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6693 27.9002V7.78349C36.6693 5.78349 35.0359 4.30015 33.0526 4.46682H32.9526C29.4526 4.76682 24.1359 6.55015 21.1693 8.41682L20.8859 8.60015C20.4026 8.90015 19.6026 8.90015 19.1193 8.60015L18.7026 8.35015C15.7359 6.50015 10.4359 4.73349 6.93594 4.45015C4.9526 4.28349 3.33594 5.78348 3.33594 7.76682V27.9002C3.33594 29.5002 4.63594 31.0002 6.23594 31.2002L6.71927 31.2668C10.3359 31.7502 15.9193 33.5835 19.1193 35.3335L19.1859 35.3668C19.6359 35.6168 20.3526 35.6168 20.7859 35.3668C23.9859 33.6002 29.5859 31.7502 33.2193 31.2668L33.7693 31.2002C35.3693 31.0002 36.6693 29.5002 36.6693 27.9002Z",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 9.1499V34.1499",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9141 14.1499H9.16406",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1641 19.1499H9.16406",
    stroke: "#1C1C1C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSampleProduct);
export default __webpack_public_path__ + "static/media/SampleProduct.7ba1eda7f761332378b2d9754fbe4eda.svg";
export { ForwardRef as ReactComponent };